import './App.css';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Graphtable from '../components/todaysignals/Graphtable';
import FilterOffcanvas from '../components/offcanvas/FilterOffcanvas';
import Header from '../components/header/Header';
import Footer from '../components/Footer';
import { initTheme } from '../utils/theme';
import TodaysignalsFilter from '../components/todaysignals/TodaysignalsFilter';
import { host } from '../utils/variablesProdTest';
import { useSelector } from 'react-redux';
import SignInModal from '../components/landing/SingInModal';
import SubscribeOnScreen from '../components/subscribeOnScreen/SubscribeOnScreen';
import AlertTopBar from '../components/todaysignals/AlertTopBar';

function App() {

  initTheme();

  const user = useSelector((state) => state.user.user);

  const [table, setTable] = useState([]);
  const [totalLines, setTotalLines] = useState(0);
  const [offset, setOffset] = useState(0);

  const volume = 0;

  const [selection, setSelection] = useState({});
  const [filter, setFilter] = useState(null);

  // --------------------------------------------
  // CHECK IF FILTERS HAVE VALUES
  // --------------------------------------------

  const hasFiltersSelected = (filterObj) => {
    return Object.values(filterObj).every(
      (arr) => Array.isArray(arr) && arr.length > 0
    );
  };

  // --------------------------------------------
  // FETCH FILTER TABLE
  // --------------------------------------------

  const fetchFilterTable = () => {

    axios.post(host + "filterTable.php", {
      subscription: user.subscription
    })
    .then((data) => {

      let parsed = JSON.parse(data.data[0].filter);

      let change = [];

      for (let i in parsed.position) {

        if (parsed.position[i] === -1) {
          change.push('short');
        } else {
          change.push('long');
        }
      }

      parsed.position = change;

      let opt = {};

      for (const [column, list] of Object.entries(parsed)) {

        opt[column] = {};

        for (let i in list) {
          opt[column][list[i]] = true;
        }
      }

      setSelection(opt);

      let res = {};

      for (const [column, list] of Object.entries(opt)) {

        let s = [];

        for (const [k, v] of Object.entries(list)) {

          if (column === 'position') {

            if (k === 'short' && v) {
              s.push('-1');
            } else if (k === 'long' && v) {
              s.push('1');
            }

          } else {

            if (v) {
              s.push(k);
            }
          }
        }

        res[column] = s;
      }

      setFilter(res);

    })
    .catch((error) => {
      console.log(error);
    });
  };

  // --------------------------------------------
  // FETCH TABLE
  // --------------------------------------------

  const fetchTable = () => {

    axios.post(host + "graficar.php", {

      strategy: filter.strategy,
      position: filter.position,
      volume: volume,
      country: filter.country,
      sector: filter.sector,
      industry: filter.industry,
      exchange: filter.exchange,
      indexes: filter.indexes,
      offset: offset

    })
    .then((response) => {

      if (Array.isArray(response.data)) {

        setTable(prevTable => [
          ...prevTable,
          ...response.data
        ]);

        setOffset(prevOffset => prevOffset + 15);

      } else {

        setTable([]);
      }
    })
    .catch((error) => {

      setTable([]);
      setOffset(0);

      console.log(error);
    });
  };

  // --------------------------------------------
  // FETCH ROW NUMBER
  // --------------------------------------------

  const fetchRowNumber = () => {

    axios.post(host + "contarRegistros.php", {

      strategy: filter.strategy,
      position: filter.position,
      volume: volume,
      country: filter.country,
      sector: filter.sector,
      industry: filter.industry,
      exchange: filter.exchange,
      indexes: filter.indexes

    })
    .then((response) => {

      console.log("ROW RESPONSE:", response.data);

      setTotalLines(
        response?.data?.[0]?.total_rows ?? 0
      );

    })
    .catch((error) => {

      setTotalLines(0);

      console.log(error);
    });
  };

  // --------------------------------------------
  // LOAD USER FILTERS
  // --------------------------------------------

  useEffect(() => {

    if (user != null) {
      fetchFilterTable();
    }

  }, [user]);

  // --------------------------------------------
  // LOAD TABLE WHEN FILTER CHANGES
  // --------------------------------------------

  useEffect(() => {

    if (filter != null) {

      // IF USER DESELECTED EVERYTHING
      if (!hasFiltersSelected(filter)) {

        setTable([]);
        setTotalLines(0);
        setOffset(0);

        return;
      }

      fetchRowNumber();
      fetchTable();
    }

  }, [filter]);

  // --------------------------------------------
  // OFFCANVAS
  // --------------------------------------------

  const [open, setOpen] = useState(false);

  const handleShow = () => {

    if (open === true) {
      filterSelection();
    }

    setOpen(!open);
  };

  // --------------------------------------------
  // MANAGE FILTER CHECKBOXES
  // --------------------------------------------

  const configureSelection = (column, field, isChecked) => {

    if (isChecked) {

      setSelection((prev) => ({
        ...prev,
        [column]: {
          ...prev[column],
          [field]: true
        }
      }));

    } else {

      setSelection((prev) => ({
        ...prev,
        [column]: {
          ...prev[column],
          [field]: false
        }
      }));
    }
  };

  // --------------------------------------------
  // APPLY FILTER
  // --------------------------------------------

  const filterSelection = () => {

    let res = {};

    for (const [column, list] of Object.entries(selection)) {

      let s = [];

      for (const [k, v] of Object.entries(list)) {

        if (column === 'position') {

          if (k === 'short' && v) {
            s.push('-1');
          } else if (k === 'long' && v) {
            s.push('1');
          }

        } else {

          if (v) {
            s.push(k);
          }
        }
      }

      res[column] = s;
    }

    setTable([]);
    setOffset(0);
    setTotalLines(0);

    setFilter(res);
  };

  // --------------------------------------------
  // RENDER
  // --------------------------------------------

  return (

    <div>

      <Header handleShow={handleShow} />

      {user && user.subscription === 'free' &&
        <SubscribeOnScreen />
      }

      {user === null &&
        <SignInModal
          show={true}
          onHide={null}
          url2navigate={null}
        />
      }

      {user &&
        <AlertTopBar />
      }

      {user &&
        <TodaysignalsFilter selection={selection} />
      }

      <FilterOffcanvas
        open={open}
        handleShow={handleShow}
        filter_options={selection}
        configureSelection={configureSelection}
        filterSelection={filterSelection}
      />

      <Graphtable
        table={table}
        totalLines={totalLines}
        offset={offset}
        fetchTable={fetchTable}
        mode={"todaySignals"}
      />

      <Footer />

    </div>
  );
}

export default App;